export const MONOGRAM_JSON_CONTAINER_SCHEMA_URL = 'https://withjoy.com/assets/public/websiteHeaderSchemas/monogramJsonContainer-v1_1_2.json' as const;
